import { useQuery } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import useApi from '../../api/backendApiContext';
import { ReactQueryConstants } from '../../commons/constants';
import { QueryStatus } from '../../commons/components/QueryStatus';

export const useFetchedInstagramAccount = () => {
  const { socialPostingApi } = useApi();
  const cacheManager = useQueryCacheManager();
  const queryKey = cacheManager.getInstagramAccountCacheKey();
  const query = useQuery(queryKey, socialPostingApi.getInstagramAccount, {
    staleTime: ReactQueryConstants.personalIntegrationSettingsStaleTime,
  });

  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="instagram"
      failedToLoadText="Something went wrong while loading Instagram integration settings."
    />
  );

  return {
    query,
    queryStatusComponent,
  };
};

